const totalGirl = ['សរុប', 'ស្រី']
const maleFemale = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ប្រុស' }, { value: 2, text: '២.ស្រី' }
]
const replacePrinciple = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.នាយករង' }, { value: 2, text: '២.គ្រូបង្រៀន' }
]
const staffType = ['បុគ្គលិកបង្រៀន', 'បុគ្គលិកមិនបង្រៀន']
const location = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.តំបន់ក្រុង' }, { value: 2, text: '២.តំបន់ជនបទ' }
]
const yesNo = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ពិតមែន' }, { value: 2, text: '២.ទេ' }
]
const yesNo2 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' }, { value: 2, text: '២.មិនមាន' }
]
const yesNo3 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.អាច' }, { value: 2, text: '២.មិនអាច' }
]
const yesNo4 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.បាទ' }, { value: 2, text: '២.ទេ' }
]
const yesNo5 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.បាន' }, { value: 2, text: '២.មិនបាន' }
]
const yesNo6 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' }, { value: 2, text: '២.គ្មាន' }
]
const yesNo7 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.នៅដំណើរការ' }, { value: 2, text: '២.មិនដំណើរការ' }
]
const condition = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ល្អ' }, { value: 2, text: '២.មធ្យម' },
  { value: 3, text: '៣.អន់' }, { value: 4, text: '៤.មិនទាន់មាន' }
]
const numShift = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មួយវេន' }, { value: 2, text: '២.ពីរវេន' },
  { value: 3, text: '៣.បីវេន' }
]
const numShift2 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មួយវេន' }, { value: 2, text: '២.ពីរវេន' }
]
const inchPos = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.នាយករង' }, { value: 2, text: '២.គ្រូបង្រៀន' }, { value: 3, text: '៣.គ្រូក្រៅក្របខ័ណ្ឌ' }
]
const disable = [
  { text: 'សិស្សពិការ', val: -1 },
  { text: 'ចំនួនសិស្សពិការ', val: 0 },
  { text: 'ប្រភេទពិការ', val: -1 },
  { text: '-ពិបាកក្នុងការធ្វើចលនា', val: 1 },
  { text: '-ពិបាកក្នុងការស្ដាប់', val: 2 },
  { text: '-ពិបាកក្នុងការនិយាយ', val: 3 },
  { text: '-ពិបាកក្នុងការមើល', val: 4 },
  { text: '-ពិការសរីរាង្គខាងក្នុង', val: 5 },
  { text: '-ពិការសតិបញ្ញា', val: 6 },
  { text: '-ពិបាកខាងផ្លូវចិត្ត', val: 7 },
  { text: '-ពិការផ្សេងៗ', val: 8 },
  { text: '-ពិការគរ ថ្លង់', val: 9 },
  { text: 'សិស្សជួបការលំបាកផ្នែកសុខភាព', val: -1 },
  { text: 'ចំនួនជួបការលំបាកផ្នែកសុខភាព', val: 10 },
  { text: 'ប្រភេទការលំបាកផ្នែកសុខភាព', val: -1 },
  { text: '-មានស្ថានភាពអាហារូបត្ថម្ភធ្ងន់ធ្ងរ', val: 11 },
  { text: '-សុខភាព/ជំងឺប្រចាំកាយ', val: 12 },
  { text: 'សិស្សជួបការលំបាក', val: -1 },
  { text: 'ចំនួនសិស្សជួបការលំបាក', val: 13 },
  { text: 'ប្រភេទការលំបាក', val: -1 },
  { text: '-មកពីគ្រួសារផ្លាស់ប្ដូរទីលំនៅ', val: 14 },
  { text: '-កុមារកំព្រា', val: 15 },
  { text: '-កុមាររងគ្រោះដោយ HIV/AIDS', val: 16 },
  { text: '-កុមាររងអំពើហិង្សាក្នុងគ្រួសារ', val: 17 },
  { text: '-កុមាររងការកេងប្រវ័ញ្ចពលកម្ម', val: 18 },
  { text: '-កុមារដែលមកពីគ្រួសារក្រីក្រ', val: 19 },
  { text: '-កុមាររងអំពើហិង្សាក្នុងសាលារៀន', val: 20 },
  { text: 'ចំនួនកុមារទទួលបាន៖', val: -1 },
  { text: '-កិច្ចអន្តរគមន៍របស់សុខាភិបាល', val: 21 },
  { text: '-កិច្ចគាំពារ និងប្រឹក្សាយោបល់', val: 22 },
]
const roomEnv = ['សរុប', 'មានអគ្គីសនី', 'មានអំពូល', 'មានកង្ហារ/ម៉ាស៊ីនត្រជាក់']
const d1 = ['ក', 'ខ', 'គ']
const d2 = ['ជំរំភៀសសឹក', 'ក្របខ័ណ្ឌ', 'តាមកិច្ចព្រមព្រៀងការងារ']
const d3 = ['ក្នុងបឋមសិក្សា', 'វិញ្ញាបនបត្របឋមសិក្សា', 'ក្នុងមធ្យមសិក្សាបឋមភូមិ', 'សញ្ញាបត្រមធ្យមសិក្សាបឋមភូមិ', 'ក្នុងមធ្យមសិក្សាទុតិយភូមិ',
  'សញ្ញាបត្រមធ្យមសិក្សាទុតិយភូមិ', 'ក្នុងមហាវិទ្យាល័យ', 'បរិញ្ញាបត្រ', 'បរិញ្ញាបត្រជាន់ខ្ពស់ (អនុបណ្ឌិត)', 'សញ្ញាបត្របណ្ឌិត']
const d4 = ['គណៈគ្រប់គ្រង', 'គ្រូក្របខណ្ឌ','គ្រូតាមកិច្ចព្រមព្រៀងការងារ','សិស្ស']
const e1 = ['ផ្ទៃដីសរុបជាកម្មសិទ្ធិរបស់សាលារៀន', ' - ទីធ្លាសាលារៀន (សម្រាប់រត់លេង និងកីឡា)', ' - ផ្ទៃក្រឡាបន្ទប់រៀន',
  ' - ផ្ទៃដីនៅសល់សម្រាប់សាងសង់', ' - ផ្ទៃក្រឡាសួនកសិកម្ម(ជីវចម្រុះ)']
const e2 = ['ធ្វើអំពីឥដ្ឋ / ស៊ីម៉ង់ (ថ្ម)', 'ធ្វើអំពីឈើ (ឈើ/ដែក)', 'ធ្វើអំពីឬស្សី / កូនឈើ']
const building = ['អគារជួសជុលថ្មី', 'អគារសាងសង់ថ្មី', 'អគារគ្មានកម្រាលល្អ', 'អគារគ្មានដំបូលល្អ', 'អគារគ្មានជញ្ជាំងល្អ/បង្អួចល្អ/ទ្វារល្អ',
  'តុសិស្ស', 'កៅអី/កៅអីវែងសម្រាប់សិស្ស', 'កៅអីសម្រាប់គ្រូ', 'តុសម្រាប់គ្រូ', 'ក្ដារខៀន']
const roomCond = ['ទីចាត់ការ', 'បណ្ណាល័យ', 'បន្ទប់អប់រំបំណិនជីវិត', 'មជ្ឈមមណ្ឌលធនធាន', 'បន្ទប់រោងជាង', 'បន្ទប់កុំព្យូទ័រ',
  'បន្ទប់ថែទាំសុខភាព', 'អន្តេវាសិកដ្ឋាន', 'បន្ទប់/ផ្ទះគ្រូស្នាក់នៅ', 'រោងបាយ', 'បន្ទប់ផ្សេងទៀត', 'ទីជម្រាលសម្រាប់កុមារ/គ្រូពិការ']
const handWashing = ['កន្លែងលាងសម្អាតដៃ (អាចប្រើបានបន្ទាប់ពីប្រើបង្គន់)', 'កន្លែងលាងសម្អាតដៃ', 'ការគ្រប់គ្រងអនាម័យពេលមានរដូវ']
const handWashingPrio = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន (សម្រាប់លាងម្នាក់ឯង)' },
  { value: 2, text: '២.មាន (សម្រាប់លាងជាក្រុម)' }, { value: 3, text: '៣.មាន (ទាំងសម្រាប់ម្នាក់ឯង និងសម្រាប់ជាក្រុម)' },
  { value: 4, text: '៤.មិនមាន' }
]
const handWashingPrio2 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' },
  { value: 2, text: '២.មានខ្លះ' }, { value: 3, text: '៣.មិនមាន' }
]
const handWashingCond = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មានសាប៊ូនិងទឹកថ្ងៃនេះ' },
  { value: 2, text: '២.មានតែទឹកថ្ងៃនេះ' }, { value: 3, text: '៣. គ្មានសាប៊ូឬទឹកទេថ្ងៃនេះ' }
]
const handWashingCond2 = [
  { value: 1, text: '១.មានសំឡីអនាម័យពេលត្រូវការបន្ទាន់' },
  { value: 2, text: '២.មានធុងសំរាមនៅបង្គន់ស្រ្តី' }, { value: 3, text: '៣.មានកន្លែងលាងសម្អាតនៅបង្គន់ស្រ្តី' }
]
const toiletRow = ['ចំនួនបង្គន់អនាម័យចាក់ទឹក/ចុចបង្ហូរទឹកសរុប', 'ចំនួនបង្គន់អនាម័យចាក់ទឹក/ចុច បង្ហូរទឹកដែលអាចប្រើបាន មានទឹក',
  'ចំនួនបង្គន់អនាម័យផ្សេងទៀត', 'ចំនួនកន្លែងនោមសិស្សប្រុស']
const water = ['បណ្តាញទុយោ', 'អណ្តូងស្នប់/អណ្តូងខួង', 'អណ្តូងជីក/ទឹកផុសចេញពីក្រោមមានការការពារ', 'ទឹកភ្លៀង',
  'ទឹកពិសាដប', 'ទឹកទិញដឹកដោយទ្បានស៊ីទែន/រទេះរុញ', 'អណ្តូងជីក/ទឹកផុសចេញពីក្រោមមិនមានការការពារ', 'ទឹកបឹង/ស្រះ/ទន្លេ/ព្រែក/អូរ/ស្ទឹង']
const facility = ['បណ្ដាញអគ្គិសនី', 'ថាមពលប្រើពន្លឺព្រះអាទិត្យ', 'ម៉ាស៊ីនភ្លើង', 'អគ្គិសនីសម្រាប់ការិយាល័យ']
const facility2 = ['កុំព្យូទ័រសរុប', 'កុំព្យូទ័រប្រើប្រាស់បាន', 'កុំព្យូទ័រសម្រាប់ការិយាល័យ', 'កុំព្យូទ័រសម្រាប់បង្រៀន និងរៀន',
  'ម៉ាស៊ីនបោះពុម្ព', 'ម៉ាស៊ីនថតចម្លង', 'ម៉ាស៊ីន Scanner', 'ម៉ាស៊ីនដេរ',
  'ម៉ាស៊ីនបញ្ចាំង LCD', 'ផ្ទាំងក្រណាត់បញ្ចាំងស្លាយ', 'ប្រអប់សង្គ្រោះបឋម និងបម្រុង', 'ខ្សែរសេវា Internet']
const elecType = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.រដ្ឋ' }, { value: 2, text: '២.ឯកជន' },
  { value: 3, text: '៣.រដ្ឋ និងឯកជន' }, { value: 4, text: '៤.គ្មាន' }
]
const sportType = ['ទីធ្លា', 'សម្ភារ', 'ក្រុមកីឡា']
const sportUtil = ['បាល់ទះ', 'បាល់ទាត់', 'បាល់បោះ', 'ឡើងខ្សែពួរ']
const sportUtil2 = ['ចោលដុំដែក', 'លោតកម្ពស់', 'លោតចម្ងាយ', 'រត់ចម្ងាយ']
const financial = ['ថវិកាកម្មវិធី PB ដែលបានទទួល (សម្រាប់ដំណើរការសាលារៀន)-', 'ថវិការដ្ឋាភិបាលសម្រាប់សាងសង់-',
  'សរុបចំណូលផលិតកម្មរបស់សាលារៀន', 'អំណោយពីសហគមន៍/សប្បុរសជនក្នុងប្រទេស', 'អំណោយសប្បុរសជនក្រៅប្រទេស',
  'អំណោយពីអង្គការអន្តរជាតិ និងអង្គការមិនមែនរដ្ឋាភិបាល', 'បុណ្យផ្សេងៗ']
const intDesc = ['សេវា Internet WiFi', 'Mobile Phone Hotspot', 'អុីនធើណេតតាមបន្ទប់សម្រាប់ការរៀន និងបង្រៀន','អុីនធើណេតសម្រាប់ការងាររដ្ឋបាលគ្រូ',
  'អុីនធើណេតសម្រាប់បណ្ណាល័យនិង​ បន្ទប់ពិសោធន៏', 'ប្រភេទសេវាអុីនធើណេត','អ្នកទទួលបន្ទុកគ្រប់គ្រងសេវាអុីនធើណេត','អគ្គិសនីសម្រាប់ការរៀន និងបង្រៀន','ថ្លៃចំណាយអគ្គិសនីប្រចាំខៃ']
const intType = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.Fiber Optic' }, { value: 2, text: '២.ADSL/DSL' },
  { value: 3, text: '៣.Fixed Wireless' }, { value: 4, text: '៤.Satellite' }, { value: 5, text: '៥.ផ្សេងៗ' }
]
const intMgt = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.រដ្ឋបាលសាលារៀន' }, { value: 2, text: '២.ការិយាល័យអ.យ.ក ក្រុង/ស្រុក/ខណ្ឌ' },
  { value: 3, text: '៣.មន្ទីរអ.យ.ក រាជធានី/ខេត្ត' }, { value: 4, text: '៤.រដ្ឋបាលថ្នាក់កណ្តាល' }, { value: 5, text: '៥.ផ្សេងៗ' }
]
const intSpeed = [
  { value: 0, text: '០.ជ្រើសរើស' }, 
  { value: 1, text: '១.ខ្សោយ' },
  { value: 2, text: '២.មធ្យម' }, 
  { value: 3, text: '៣.ល្អ' }
]
const intAffair = [
  { value: 0, text: '០.ជ្រើសរើស' }, 
  { value: 1, text: '១.ពន្លឿនប្រសិទ្ធភាពការងារ' },
  { value: 2, text: '២.មិនពន្លឿនប្រសិទ្ធភាពការងារ' }  
]
const intDes = [
  { value: 0, text: '០.ជ្រើសរើស' }, 
  { value: 1, text: '១.ខ្សោយ' },
  { value: 2, text: '២.មធ្យម' },
  { value: 3, text: '៣.ល្អ' }
]
/* Configuration ON-OFF cells */
const toiletOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 1, 0, 0, 0, 1]
]
const buildingOnOff = [
  [1, 1], [1, 1], [1, 1], [1, 1], [1, 1],
  [1, 0], [1, 0], [1, 0], [1, 0], [1, 0]
]
const e1OnOff = [
  [0, 0, 1], [0, 0, 1], [0, 0, 1], [1, 1, 1], [0, 0, 1]
]
const degree = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ក្នុងបឋមសិក្សា' }, { value: 2, text: '២.វិញ្ញាបនប័ត្របឋមសិក្សា' },
  { value: 3, text: '៣.ក្នុងមធ្យមសិក្សាបឋមភូមិ' }, { value: 4, text: '៤.សញ្ញាប័ត្រមធ្យមសិក្សាបឋមភូមិ' }, { value: 5, text: '៥.ក្នុងមធ្យមសិក្សាទុតិយភូមិ' },
  { value: 6, text: '៦.សញ្ញាប័ត្រមធ្យមសិក្សាទុតិយភូមិ' }, { value: 7, text: '៧.ក្នុងមហាវិទ្យាល័យ' }, { value: 8, text: '៨.បរិញ្ញាប័ត្រ' },
  { value: 9, text: '៩.បរិញ្ញាប័ត្រជាន់ខ្ពស់ (អនុបណ្ឌិត)' }, { value: 10, text: '១០.សញ្ញាប័ត្របណ្ឌិត' }
]
const e2n = ['ធ្វើអំពីឥដ្ឋ/ស៊ីម៉ង់(ថ្ម)', 'ធ្វើអំពីឈើ(ឈើ/ដែក)', 'ធ្វើអំពីឬស្សី/កូនឈើ', 'សរុប']
/*
const e2n = [
  { value: 0, text: '០.ជ្រើសរើស' },
  { value: 1, text: '១.ថ្ម' },
  { value: 2, text: '២.ឈើ' },
  { value: 3, text: '៣.ឫស្សី' },
  { value: 4, text: '៤.ផ្សេងៗ' },
]
const buildBy = [
  { value: 0, text: 'ជ្រើសរើស' },
  { value: 1, text: 'រដ្ឋាភិបាល' },
  { value: 2, text: 'សប្បុរសជន' },
  { value: 3, text: 'UNESCO' },
  { value: 4, text: 'UNICEF' },
  { value: 5, text: 'ADB' },
  { value: 6, text: 'WORLD BANK' },
  { value: 7, text: 'UNDP' },
  { value: 8, text: 'ផ្សេងៗ' }
]
const buildQty = [
  { value: 0, text: '០.ជ្រើសរើស' },
  { value: 1, text: '១.ល្អ' },
  { value: 2, text: '២.មធ្យម' },
  { value: 3, text: '៣.អន់' }
]
*/
const roomfac = [
  'តុសិស្សអង្គុយម្នាក់ៗ', 'តុសិស្សអង្គុយពីរនាក់', 'កៅអី/កៅអីវែងសម្រាប់សិស្សអង្គុយច្រើននាក់', 'កៅអីសម្រាប់គ្រូ', 'តុសម្រាប់គ្រូ', 'ក្ដារខៀន'
]

const gResult = [
  'ល្អប្រសើរ (A)',
  'ល្អណាស់ (B)',
  'ល្អ (C)',
  'ល្អបង្គួរ (D)',
  'មធ្យម (E)',
  'មិនជាប់ចំណាត់ថ្នាក់ (F)'
]

const comText = [
  'គណៈកម្មការគ្រប់គ្រងសាលារៀន',
  'សហគមន៍បានចូលរួមជួយគាំទ្រ មូលនិធិដំណើការសាលារៀន',
  'នាយក នាយករងបានទទួលការហ្វឹកហាត់កម្មវិធីគ្រប់គ្រងសាលារៀនគំរូ',
  'សាលារៀនបានទទួលការចុះពិនិត្យតាមដាន និងផ្តល់ការគាំទ្រ ពីថ្នាក់ជាតិ',
  'សាលារៀនបានទទួលការចុះពិនិត្យតាមដាន និងផ្តល់ការគាំទ្រ ពីថ្នាក់ក្រោមជាតិ'
]
const comDesc = [
  'ចំនួនដងនៃអង្គប្រជុំក្នុងឆ្នាំកន្លងមក៖',
  'ចំនួនដងនៃការចូលរួមគាំទ្រ៖',
  'ចំនួនដងនៃការចូលរួមហ្វឹកហាត់៖',
  'ចំនួនដង៖',
  'ចំនួនដង៖'
]
const plaText = [
  'សាលារៀនមានការរៀបចំផែនការសាលារៀនបានត្រឹមត្រូវ',
  'សាលារៀនមានផែនការយុទ្ធសាស្ត្រអភិវឌ្ឍ ៥ឆ្នាំ',
  'សាលារៀនរៀបចំផែនការយុទ្ធសាស្ត្រថវិកា ៣ឆ្នាំ',
  'សាលារៀនរៀបចំផែនកាប្រតិបត្តិប្រចាំឆ្នាំ និងផែនការថវិកាប្រចាំឆ្នាំ'
]
export {
  inchPos,
  totalGirl, maleFemale, staffType, location, yesNo, yesNo2, yesNo3, yesNo4, yesNo5, yesNo6, yesNo7, condition,
  numShift, numShift2, disable, roomEnv, d1, d2, d3, d4, e1, e2, building, roomCond,
  handWashing, handWashingCond, handWashingCond2, handWashingPrio, handWashingPrio2,
  toiletRow, water, facility, facility2, elecType, sportType, sportUtil, sportUtil2,
  financial, e2n,
  toiletOnOff, buildingOnOff, e1OnOff, replacePrinciple, degree, intSpeed, intType, intDesc, intMgt, intAffair,
  intDes, roomfac, gResult, comText, comDesc, plaText
}
